<template>
  <v-container v-if="visible">
    <v-card>
      <v-card-text>
        <v-container>
          <v-layout row wrap>
            <v-list two-line>
              <div v-for="remark in currentHistory" v-bind:key="remark.date" class="tile-wrapper">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title v-if="remark.name">
                      Door {{ remark.name }} <span
                        v-if="remark.status"> gewijzigd naar  <b>{{ renderStatus(remark.status) }}</b></span>
                    </v-list-tile-title>
                    <v-list-tile-title v-else>
                      Gewijzigd naar <b>{{ renderStatus(remark.status) }}</b>
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      <span class='text--primary'>{{ renderDate(remark.date) }}</span>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <div class="remark"> {{ remark.remark }}</div>
              </div>
            </v-list>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeForm" color="primary">Sluiten</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<style>
div.remark {
  white-space: pre-wrap;
  margin-left: 16px;
}
div.tile-wrapper {
  text-align: left;
}
</style>
<script>
import {mapGetters, mapActions} from "vuex";
import {sharedStatusService} from "@/services/shared";
import moment from "moment";

export default {
  name: "StatusHistory",
  props: ["visible"],
  computed: {
    ...mapGetters(["currentHistory"])
  },
  methods: {
    ...mapActions(["updatePhone1", "updatePhone2"]),
    closeForm() {
      this.$parent.closeHistory();
    },
    renderDate(date) {
      if (date) {
        var curMoment = moment(date);
        curMoment.locale("nl");
        return curMoment.format("dddd D MMMM YYYY");
      }
      return "onbekend";
    },
    renderStatus(statusKey) {
      return sharedStatusService.resolveLabel(statusKey);
    }
  }
};
</script>
